/**
 * Власник звуку (NTF-19; notifications-channels.md, розд. 2): остання активна вкладка. Вкладка на
 * `pointerdown` / `keydown` пише свій id у `localStorage`. Окремо від `sound.ts`, бо це частина
 * чанка `notifications-live` (його статично бере картка), а тон — лінивий чанк.
 */
const OWNER_KEY = 'cl:sound-owner';

/** Id вкладки в пам'яті: перезавантаження — нова вкладка, жесту в неї ще немає. */
const tabId = Math.random().toString(36).slice(2);

export function isSoundOwner(): boolean {
  try {
    return localStorage.getItem(OWNER_KEY) === tabId;
  } catch {
    return false;
  }
}

/** Ця вкладка стає власником на жест людини, `onClaim` — тоді ж. Повертає відписку. */
export function trackSoundOwner(onClaim?: () => void): () => void {
  const claim = () => {
    if (isSoundOwner()) return;
    try {
      localStorage.setItem(OWNER_KEY, tabId);
    } catch {
      // Сховище недоступне: звуку не буде, а решта працює.
      return;
    }
    onClaim?.();
  };
  const options = { capture: true, passive: true };
  window.addEventListener('pointerdown', claim, options);
  window.addEventListener('keydown', claim, options);
  return () => {
    window.removeEventListener('pointerdown', claim, options);
    window.removeEventListener('keydown', claim, options);
  };
}

/** Браузер не дасть грати, поки на сторінці не було жесту; API немає — невідомо, пробуємо. */
export function soundBlocked(): boolean {
  return navigator.userActivation?.hasBeenActive === false;
}
